export const Container: any = {
  baseStyle: {
    maxWidth: '1440px',
  },
}
